import { connect } from 'react-redux';
import MonthlyLoan from './MonthlyLoan';
import { getAnnualResults } from '../selectors';

import { setSelectedFinancing } from '../../../../common/settings/actions';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    selectedFinancing: state.settings.selectedFinancing,
    ppaRate: state.ppa.rate,
    ppaTerm: state.ppa.term,
    ppaEscalator: state.ppa.escalator,
    loanTerm: state.loan.loanTerm,
    downPayment: state.loan.downPayment,
    mosaicDownPayment: state.loan.mosaicDownPayment,
    loanProvider: state.loan.loanProvider,
    resiToggle: state.tax.resiToggle,
    loanInterest: state.loan.interest,
    mosaicTerm: state.loan.mosaicTerm,
    mosaicFee: state.loan.mosaicFee,
    cashprice: state.solar.cashprice,
    systemSize: state.solar.systemSize,
    formattedSystemPrice: state.solar.systemSize,
    provider: state.utility.provider,
    annualInflation: state.utility.annualInflation,
    setSelectedFinancing,
    doughnutSlider: state.settings.doughnutSlider,
    taxEntity: state.tax.taxEntity,
    projectState: state.projectaddress.projectState,
    sgipToggle: state.sgip.sgipToggle,
    includeESS: state.ess.includeESS,
    essPrice: state.ess.essPrice,
    taxRate: state.tax.taxRate,
    projectName: state.projectaddress.projectName,
});

const combinedActions = {
    setSelectedFinancing,
};

export default connect(mapStateToProps, combinedActions)(MonthlyLoan);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/MonthlyLoan/index.js